import { create } from 'zustand';
import { BrandingColors } from './branding-types';
import { shepherdTheme } from './shepherd';

export type BrandingState = {
  colors: BrandingColors;
  setColors: (colors: BrandingColors) => void;
};

const useBrandingStateStore = create<BrandingState>((set) => ({
  colors: shepherdTheme,
  setColors: (colors) => set({ colors })
}));

export const useColors = () => useBrandingStateStore((state) => state.colors);
export const useSetColors = () => useBrandingStateStore((state) => state.setColors);
